import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';

const socialLinks = () => {
  const classes = 'block hover:text-amber-500 leading-none';

  return (
    <div className="flex items-center gap-2 ml-auto">
      <a
        href="https://github.com/dwheeldo"
        target="_blank"
        rel="noopener noreferrer"
        className={classes}
      >
        <FontAwesomeIcon icon={faGithub} size="xl" />
        <span className="sr-only">Github</span>
      </a>

      <a
        href="https://www.linkedin.com/in/david-wheeldon-7043b516b"
        target="_blank"
        rel="noopener noreferrer"
        className={classes}
      >
        <FontAwesomeIcon icon={faLinkedin} size="xl" />
        <span className="sr-only">LinkedIn</span>
      </a>
    </div>
  );
};

export default socialLinks;
